import store from '@/store'
import axios from '@axios'

import { computed } from '@vue/composition-api'

export default function useCalendarSidebar() {
    const fetchCalendarOptions = () => {
        // Aquí puedes hacer la llamada axios para obtener las opciones del calendario
        // y luego actualizar el estado de la tienda Vuex con las opciones obtenidas
        // Ejemplo:
         axios.get('/finanzas/gastos/proveedor')
             .then(response => {
                const providerNames = response.data.map(item => item.label);
                store.commit('calendar/SET_CALENDAR_OPTIONS', response.data);
                store.commit('calendar/SET_SELECTED_EVENTS', providerNames);
             })
             .catch(error => {
                 console.error('Error al obtener las opciones del calendario:', error);
             });        
    };

    // ------------------------------------------------
    // calendarOptions
    // ------------------------------------------------
    const calendarOptions = computed(() => store.state.calendar.calendarOptions)    

    // ------------------------------------------------
    // selectedCalendars
    // ------------------------------------------------
    const selectedCalendars = computed({
        get: () => store.state.calendar.selectedCalendars,
        set: val => {
            store.commit('calendar/SET_SELECTED_EVENTS', val)
        },
    })

    // ------------------------------------------------
    // checkAll
    // ------------------------------------------------
    const checkAll = computed({
        /*
          GET: Return boolean `true` => if length of options matches length of selected filters => Length matches when all events are selected
          SET: If value is `true` => then add all available options in selected filters => Select All
               Else if => all filters are selected (by checking length of both array) => Empty Selected array  => Deselect All
        */
        get: () => selectedCalendars.value.length === calendarOptions.value.length,
        set: val => {
            if (val) {
                selectedCalendars.value = calendarOptions.value.map(i => i.label)
            } else if (selectedCalendars.value.length === calendarOptions.value.length) {
                selectedCalendars.value = []
            }
        },
    })

    return {
        calendarOptions,
        selectedCalendars,
        checkAll,
        fetchCalendarOptions
    }
}